<template>
  <ul class="nav nav-mobile-menu">
    <li class="nav-item">
      <a class="nav-link" @click.prevent="logout">
        <i class="fa fa-sign-out hidden-lg-up"></i>
        <span class="d-lg-none">Cerrar sesión</span>
      </a>
    </li>
  </ul>
</template>
<script>
  import DropDown from 'src/components/UIComponents/Dropdown.vue'

  export default {
    components: {
      DropDown
    },
    methods: {
      logout () {
        localStorage.removeItem('api_token')
        this.$router.go('/')
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/MobileMenu.vue